// client/src/admin/AdminApp.jsx
import * as React from 'react';
import { Admin, Resource } from 'react-admin';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';
import { FornitoreList, FornitoreEdit, FornitoreCreate } from './resources/fornitori';
import { ServizioList, ServizioEdit, ServizioCreate } from './resources/servizi';
import { FasciaList, FasciaEdit, FasciaCreate } from './resources/fasceOrarie';
import StoreIcon from '@mui/icons-material/Store';
import BuildIcon from '@mui/icons-material/Build';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export default function AdminApp() {
  return (
    <Admin basename="/react-admin" authProvider={authProvider} dataProvider={dataProvider}>
      <Resource
        name="fornitori"
        list={FornitoreList}
        edit={FornitoreEdit}
        create={FornitoreCreate}
        icon={StoreIcon}
      />
      <Resource
        name="servizi"
        list={ServizioList}
        edit={ServizioEdit}
        create={ServizioCreate}
        icon={BuildIcon}
      />
      <Resource
        name="fasceOrarie"
        list={FasciaList}
        edit={FasciaEdit}
        create={FasciaCreate}
        icon={AccessTimeIcon}
      />
    </Admin>
  );
}
